import { j as i } from "./jsx-runtime-944c88e2.js";
import { Box as t, Stack as y, Text as r, Heading as F, Button as b } from "@chakra-ui/react";
import { u as C, T as s } from "./eMyAsurionProvider-5bc36307.js";
import "@tanstack/react-query";
import "react";
import "./useAccount-a03adfa5.js";
import "./myasurion-shared.mixpanel.es.js";
import "@chakra-ui/icons";
import "./features-979fdcf7.js";
import "./providers-29a9425c.js";
import "react-router-dom";
import "./cleave-react-node-c4a374e5.js";
import "./lodash-9598aa3c.js";
import "@react-oauth/google";
import "./domains-7d097fe4.js";
import "./myasurion-shared.carrier.es.js";
import "framer-motion";
import "./myasurion-shared.widgets.es.js";
import "./myasurion-shared.utils.es.js";
import "./myasurion-shared.colors.es.js";
import "@emotion/react";
import "./ProfileIcon-8cf21b72.js";
import "./myasurion-shared.profile.es.js";
import "react-dom";
import "mixpanel-browser";
import "@emotion/styled";
const V = ({
  title: d,
  desc: x,
  desc2: o,
  desc3: p,
  feeText: h,
  deviceServiceButtonProps: l,
  ...m
}) => {
  const { data: j } = C(), { theme: f } = j, { colors: n } = f, g = "DeviceService";
  return /* @__PURE__ */ i.jsx(
    t,
    {
      id: "myasurion-deviceservice",
      borderRadius: "1px",
      minH: "166px",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "gray.300",
      bg: "gray.200",
      p: "16px",
      ...m,
      children: /* @__PURE__ */ i.jsxs(y, { children: [
        m.tag && /* @__PURE__ */ i.jsx(t, { m: "0", mb: "15px", children: /* @__PURE__ */ i.jsx(t, { m: 0, p: "4px", maxW: "120px", bg: "#FFFFFF", borderRadius: "4px", children: /* @__PURE__ */ i.jsx(r, { fontSize: "xs", children: m.tag }) }) }),
        /* @__PURE__ */ i.jsx(F, { fontSize: "2xl", fontWeight: "light", children: d }),
        x && /* @__PURE__ */ i.jsx(r, { children: x }),
        o && /* @__PURE__ */ i.jsx(r, { mt: "12px", children: o }),
        /* @__PURE__ */ i.jsx(r, { fontWeight: "bold", fontSize: (m.tag, "lg"), children: h }),
        p && /* @__PURE__ */ i.jsx(r, { mt: "", children: p }),
        m.tag ? /* @__PURE__ */ i.jsx(
          b,
          {
            isDisabled: l.disable,
            padding: "0px",
            variant: "outline",
            bg: "#F0F0F5",
            h: { base: "28px", lg: "30px" },
            w: { base: "135px", lg: "50%" },
            m: { base: "0px", lg: "auto" },
            fontWeight: "bold",
            borderColor: n.primary,
            color: n.primary,
            onClick: () => {
              var a;
              return (a = l.onClick) == null ? void 0 : a.call(l);
            },
            children: /* @__PURE__ */ i.jsx(
              s,
              {
                text: l.label,
                translationKey: `${g}/${l.label}`
              }
            )
          }
        ) : /* @__PURE__ */ i.jsx(
          b,
          {
            isDisabled: l.disable,
            paddingX: "20px",
            paddingY: "12px",
            colorScheme: "primary",
            w: { base: "full", lg: "50%" },
            m: "auto",
            onClick: () => {
              var a;
              return (a = l.onClick) == null ? void 0 : a.call(l);
            },
            children: /* @__PURE__ */ i.jsx(
              s,
              {
                text: l.label,
                translationKey: `${g}/${l.label}`
              }
            )
          }
        )
      ] })
    }
  );
};
export {
  V as DeviceService
};
